module.exports = __webpack_public_path__ + "static/media/SourceIcon.7540c264.svg";